import React from 'react';
import './bestDev.css';
import { FaArrowRight } from "react-icons/fa";
import { useTranslation } from 'react-i18next';
import { FaRegLightbulb, FaCode} from "react-icons/fa";
import { MdOutlineDesignServices } from "react-icons/md";
import { LiaToolsSolid } from "react-icons/lia";
import LogoClient from "../LogoClients/LogoClients";
 function ColumnaBest({ icon: Icon, title }) {

  return (
    <div class="col-6 col-md-6 col-lg-3 col-sm-6">
      <div className='icons'>
        <div className='bg-white text-center'>
            <Icon size="100%" />
        </div>
        <h3 className='text-center w_color'>{title}</h3>
      </div>
    </div>


  )
}

export default function BestDev() {

 const { t } = useTranslation();
 //const section = t('stories.customers_stories', { returnObjects: true })

  return (
    <section className='bestdev sec--area'>
        <div class="container">
          <div className='mb-5'>
            <h2 className="line-break w_color f_700 z-index99 text-center">
                {t("best_dev.title")}
            </h2>
            <p className='f--size-20 pt-3 pb-5 w_color text-center'>{t("best_dev.sub_title")}  
              <a href='/#Formulario' className="f_700 m_color">{t("landing_form.title")} 
              <FaArrowRight />            
              </a>
            </p>
          </div>
          <div class="row">
              <ColumnaBest title={t("best_dev.icon_create")} icon={FaRegLightbulb}/>
              <ColumnaBest title={t("best_dev.icon_design")} icon={MdOutlineDesignServices}/>
              <ColumnaBest title={t("best_dev.icon_implementation")} icon={LiaToolsSolid}/>
              <ColumnaBest title={t("best_dev.icon_support")} icon={FaCode}/>
          </div>
          <div className='mt-5 text-center'>
            <p className='f--size-20 w_color'>{t("best_dev.title_customers")}</p>
            <div>
              <LogoClient classDiv=" align-items-center logos-container"/>
            </div>
          </div>
        </div>
    </section>
  )
}

